import { useTranslation } from "react-i18next";

import { useNavigationCollapse } from "../context/NavigationContext";

/**
 * Full-height hit area on the navigation edge.
 * Hover shows a divider; click toggles the collapsed state.
 */
const CollapseEdge = () => {
    const { t } = useTranslation();
    const { isCollapsed, toggleCollapsed } = useNavigationCollapse();

    const label = isCollapsed ? t("NavigationBar.ExpandNavigation") : t("NavigationBar.CollapseNavigation");

    return <button type="button" className="navigation-collapse-edge" onClick={toggleCollapsed} aria-label={label} />;
};

export default CollapseEdge;
